import axios from "axios";
export const authAppWidthOAuth2 = code => {
  return axios.get("/api/authz/oauth2/idp_authorize", {
    params: {
      appCode: code,
      state: 1
    }
  });
};
export const authorizeWithOAuth2 = params => {
  console.log(params);
  return axios.get("/api/authz/oauth2/authorize", {
    params
  });
};